import { render, staticRenderFns } from "./reports-page.vue?vue&type=template&id=f8bb6c44&scoped=true"
import script from "./reports-page.vue?vue&type=script&lang=js"
export * from "./reports-page.vue?vue&type=script&lang=js"
import style0 from "./reports-page.vue?vue&type=style&index=0&id=f8bb6c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bb6c44",
  null
  
)

export default component.exports